/* @flow */

import requestService from '@/services/request'
import Sentry from '@/services/analytics/Sentry'
import { amountFunction, lmsrPrice, lmsrShares, sharesFromCostPowell } from '@/api/price'
import { Decimal } from 'decimal.js'

// function analyticsData(wagerResponse, shares) {
//   const outcome = !isFinite(wagerResponse.outcome)
//     ? wagerResponse.outcome
//     : wagerResponse.question.outcomes.find(outcome => {
//         return outcome.id === wagerResponse.outcome
//       })

//   const outcomeName = 'title' in outcome ? outcome.title : ''
//   const currency = wagerResponse.currency

//   return {
//     productType: currency === 'OOM' ? 'Play Money' : 'Real Money',
//     currency,
//     outcome: outcome.id,
//     outcome_name: outcomeName,
//     question: wagerResponse.question.id,
//     question_name: wagerResponse.question.title,
//     scoring_rule: wagerResponse.question.scoring_rule,
//     wager: wagerResponse.id,
//     transaction_value: wagerResponse.total_amount,
//     shares,
//   }
// }
class WagerService {
  retrieve(id) {
    return new Promise((resolve, reject) => {
      requestService.get(`/wagers/${id}/`).then(response => {
        if (response.status !== 200) {
          return reject(new Error(`server error${response.status}`))
        }
        return resolve(response.json())
      })
    })
  }

  getAmount(scoring_rule, outcomeList, outcomeIndex, shares, tax, position, exchangeRate = 1) {
    /**
     * ! 'basic' and 'lmsr' scoring rules are deprecated
     */

    var price
    switch (scoring_rule) {
      case 'basic':
        //price = outcome.price[currencyId] * shares
        break
      case 'lmsr':
        price = lmsrPrice()
        break
      case 'lslmsr':
        price = amountFunction(outcomeList, outcomeIndex, shares, tax, position)
        break
      default:
        // Sentry.log(new Error('Invalid question scoring_rule'))
    }

    return price * exchangeRate
  }

  getShares(scoring_rule, outcomeList, outcomeIndex, amount, tax, position) {
    /**
     * ! 'basic' and 'lmsr' scoring rules are deprecated
     */
    switch (scoring_rule) {
      case 'basic': // ![deprecated]
        return // amount / outcome.price[currencyId]
      case 'lmsr': // ![deprecated]
        return lmsrShares()
      case 'lslmsr':
        return sharesFromCostPowell(outcomeList, amount, outcomeIndex, tax, position)
      default:
        Sentry.log(new Error('Invalid question scoring_rule'))
    }
  }

  roundPrice(price, decimalPlaces) {
    const number = new Decimal(price || 0)
    return number.toDecimalPlaces(decimalPlaces).toNumber()
  }

  ceilPrice(price, decimalPlaces) {
    const number = new Decimal(price || 0)
    return number.toDecimalPlaces(decimalPlaces, Decimal.ROUND_UP).toNumber()
  }

  floorPrice(price, decimalPlaces) {
    const number = new Decimal(price || 0)
    return number.toDecimalPlaces(decimalPlaces, Decimal.ROUND_DOWN).toNumber()
  }

  /**
   * Place a limit order
   * @param {number|string} outcomeId - The ID of the outcome
   * @param {number} shares - The number of shares (negative for short positions)
   * @param {number} price - The limit price per share
   * @param {string} currency - The currency code (e.g., 'BTC', 'USDC', 'OOM')
   * @param {string} side - The side of the order ('bid' or 'ask')
   * @param {string} position - The position type ('long' for long or 'short' for short)
   * @param {string} expiration - The expiration option ('until_cancelled', 'end_of_day', 'custom')
   * @param {Date} [expirationDate] - The custom expiration date (if expiration is 'custom')
   * @param {boolean} [cancelConflictingOrders] - Whether to cancel conflicting orders
   * @returns {Promise} - A promise that resolves to the created limit order.
   */
  placeLimitOrder(outcomeId, shares, price, currency, side, position, expiration, expirationDate, place, amount, cancelConflictingOrders = false) {
    const payload = {
      outcome: outcomeId,
      shares: shares,
      currency: currency,
      side: side,
      position: position,
      place: place, 
    }

    if (amount !== null && amount !== undefined) {
      payload.amount = amount
    }

    // Only add price if it's not null or undefined
    if (price !== null && price !== undefined) {
      payload.price = this.roundPrice(price, 2)
    }

    // Add expiration fields if provided
    if (expiration && expiration !== 'until_cancelled') {
      payload.expiration_type = expiration

      if ((expiration === 'custom' || expiration === 'end_of_day') && expirationDate) {
        payload.expired_at = expirationDate.toISOString()
      }
    }

    // Add cancel conflicting orders flag if provided
    if (cancelConflictingOrders) {
      payload.cancel_conflicting_orders = true
    }

    return requestService.post('/orders/', payload)
  }
}

const instance = new WagerService()
export default instance
